import { createContext, useRef, useState } from "react";
import { getUUID } from "../Utils/utilities";
import ErrorPrompt from "../Components/Prompts/ErrorPrompt.jsx";
import SuccessPrompt from "../Components/Prompts/SuccessPrompt.jsx";
import translate from "../Utils/translate";

const PromptContext = createContext(null);

const ERROR = "error";
const SUCCESS = "success";

export function PromptContextProvider({ children }) {
  const [prompts, setPrompts] = useState([]);
  const promptRef = useRef(prompts);

  function createError(error, customMessage) {
    const id = getUUID();

    createPrompt({
      serverMessage: customMessage ?? error?.errors ?? null,
      status: error?.status ?? null,
      title: error?.message ?? translate("errors.unexpected_error"),
      type: ERROR,
      id,
    });

    return id;
  }

  function createSuccess(customMessage) {
    const id = getUUID();

    createPrompt({
      serverMessage: customMessage ?? null,
      status: 200,
      title: translate("success.message"),
      type: SUCCESS,
      id,
    });

    return id;
  }

  function clearPrompt(id) {
    const prompt = promptRef.current.filter((prompt) => prompt.id !== id);

    promptRef.current = prompt;
    setPrompts(prompt);
  }

  function createPrompt(prompt) {
    const promptExists = prompts.filter((elem) => elem?.serverMessage === prompt?.serverMessage);

    if (promptExists.length) {
      return null;
    }

    setPrompts((prevPrompts) => {
      promptRef.current = [...prevPrompts, prompt];
      return promptRef.current;
    });
  }

  return (
    <PromptContext.Provider value={{ createError, createSuccess, clearPrompt }}>
      <section className="absolute z-[999] w-full flex flex-col items-center pointer-events-none md:items-end md:pr-default">
        {prompts.length
          ? prompts?.map((prompt) => {
              switch (true) {
                case prompt?.type?.includes(ERROR):
                  return <ErrorPrompt key={prompt.id} prompt={prompt} />;

                case prompt?.type?.includes(SUCCESS):
                  return <SuccessPrompt key={prompt.id} prompt={prompt} />;

                default:
                  break;
              }
            })
          : null}
      </section>
      {children}
    </PromptContext.Provider>
  );
}

export default PromptContext;
